import teamsByNation from './teamsByNation';

const TEAM_SEARCH_ALIASES = {
  'Inter Milan': ['internazionale', 'internazionale milano', 'inter'],
  'AS Roma': ['roma'],
  'Olympique de Marseille': ['marseille'],
  'AS Monaco': ['monaco'],
  'Union Berlin': ['1.fc union berlin', '1 fc union berlin'],
  'Lille': ['lille osc', 'losc lille', 'losc'],
  'AC Milan': ['milan'],
  'Atlético Madrid': ['atletico madrid'],
  'Paris Saint-Germain': ['psg', 'paris sg']
};

/**
 * Flattens and processes team data for fast searchable autocomplete
 * Returns an array of objects with team info for easy lookup
 */
export const getAllTeams = () => {
  const allTeams = [];
  
  teamsByNation.forEach((nation) => {
    nation.leagues.forEach((league) => {
      league.teams.forEach((team) => {
        const aliases = TEAM_SEARCH_ALIASES[team] || [];
        const aliasSearchText = aliases.join(' ');

        allTeams.push({
          name: team,
          league: league.league,
          nation: nation.nation,
          searchText: `${team} ${league.league} ${nation.nation} ${aliasSearchText}`.toLowerCase(),
          displayText: `${team} (${league.league})`
        });
      });
    });
  });

  // Add "Custom Team" option at the end
  allTeams.push({
    name: 'Custom Team',
    league: 'Custom',
    nation: 'Custom',
    searchText: 'custom team create own'.toLowerCase(),
    displayText: 'Create Your Own Team'
  });

  return allTeams;
};

/**
 * Searches teams by query string
 * @param {string} query - Search query
 * @returns {array} Filtered teams
 */
export const searchTeams = (query) => {
  if (!query || query.trim() === '') {
    return getAllTeams();
  }

  const normalizedQuery = query.toLowerCase().trim();
  const allTeams = getAllTeams();

  return allTeams.filter((team) =>
    team.searchText.includes(normalizedQuery)
  ).sort((a, b) => {
    // Prioritize exact match at start of team name
    const aStartsWith = a.name.toLowerCase().startsWith(normalizedQuery);
    const bStartsWith = b.name.toLowerCase().startsWith(normalizedQuery);
    
    if (aStartsWith && !bStartsWith) return -1;
    if (!aStartsWith && bStartsWith) return 1;
    
    return 0;
  });
};
